export const securitySummary = {
  openAlerts: 7,
  criticalOpen: 2,
  resolvedToday: 4,
  integrityOk: true,
  lastScanAt: "2026-10-11 09:40",
  integrityBaselineAt: "2026-09-28 22:15",
  watchedFiles: 148,
};

export const integrityBaseline = {
  algorithm: "sha256",
  watchedFiles: 148,
  baselineCreatedAt: "2026-09-28 22:15",
  lastVerifiedAt: "2026-10-11 09:40",
  status: "clean",
  changes: [],
};

export const securityAlerts = [
  {
    id: "sec-1",
    severity: "critical",
    type: "SQL Injection",
    title: "Suspicious SQL payload in directory search",
    detail: "Query string contained ' UNION SELECT' and comment markers aimed at the search endpoint.",
    source: "public/search",
    subject: "/api/public/search?q=...UNION SELECT...",
    ip: "103.21.44.19",
    status: "open",
    detectedAt: "2026-10-11 09:38",
    resolvedAt: null,
  },
  {
    id: "sec-2",
    severity: "critical",
    type: "Brute Force",
    title: "Repeated failed logins for one account",
    detail: "18 failed login attempts within 4 minutes against a single owner account.",
    source: "auth/login",
    subject: "owner@mysoreyellowpages.com",
    ip: "45.155.204.7",
    status: "open",
    detectedAt: "2026-10-11 08:12",
    resolvedAt: null,
  },
  {
    id: "sec-3",
    severity: "high",
    type: "Spam Content",
    title: "Spam pattern in a new listing description",
    detail: "Description contained a casino URL and an unrelated cryptocurrency promotion.",
    source: "businesses",
    subject: "Mylari Mane Cloud Kitchen",
    ip: "182.68.221.90",
    status: "open",
    detectedAt: "2026-10-11 07:55",
    resolvedAt: null,
  },
  {
    id: "sec-4",
    severity: "high",
    type: "File Integrity",
    title: "Unexpected change to a PHP handler",
    detail: "forms/contact.php hash changed outside a deploy window.",
    source: "integrity",
    subject: "public/forms/contact.php",
    ip: "—",
    status: "open",
    detectedAt: "2026-10-10 23:41",
    resolvedAt: null,
  },
  {
    id: "sec-5",
    severity: "medium",
    type: "Spam Content",
    title: "Lead form filled with gibberish",
    detail: "Honeypot tripped and the message field matched a known bot keyword pattern.",
    source: "forms/contact",
    subject: "contact form",
    ip: "5.188.206.14",
    status: "open",
    detectedAt: "2026-10-10 19:03",
    resolvedAt: null,
  },
  {
    id: "sec-6",
    severity: "medium",
    type: "Rate Limit",
    title: "Enquiry endpoint hit from several IPs",
    detail: "Distributed burst of 60 submissions to /forms/business-enquiry.php in 10 minutes.",
    source: "forms/business-enquiry",
    subject: "distributed burst",
    ip: "104.28.0.0/16 range",
    status: "resolved",
    detectedAt: "2026-10-10 14:20",
    resolvedAt: "2026-10-10 15:02",
  },
  {
    id: "sec-7",
    severity: "low",
    type: "Scraper",
    title: "High-volume crawl of listing pages",
    detail: "One client requested 3,400 listing pages in an hour — flagged as aggressive scraping.",
    source: "web",
    subject: "user-agent: python-requests",
    ip: "66.249.66.1",
    status: "resolved",
    detectedAt: "2026-10-09 11:10",
    resolvedAt: "2026-10-09 12:44",
  },
];

export const securityScanFindings = [
  {
    id: "scan-1",
    severity: "high",
    type: "Spam Content",
    title: "Casino link in a pending review comment",
    detail: "Comment for Cauvery Grand Hotel contained an external gambling URL.",
    subject: "review · Cauvery Grand Hotel",
    matchedPattern: "casino|betting",
  },
  {
    id: "scan-2",
    severity: "medium",
    type: "Spam Content",
    title: "Repeated promotional phone number",
    detail: "The same phone number appeared in 6 new lead messages within an hour.",
    subject: "leads · 6 entries",
    matchedPattern: "repeated phone",
  },
  {
    id: "scan-3",
    severity: "low",
    type: "SEO Spam",
    title: "Keyword stuffing in a listing title",
    detail: "Title repeated 'best coaching mysore' four times.",
    subject: "business · Akshara Academy",
    matchedPattern: "keyword stuffing",
  },
];